import { useId } from 'react'

import './form.css'

/**
 * 검색창 — 와이어프레임 `SEARCH` 1380행 · `.search` CSS 476행.
 *
 * 돋보기는 장식이다. 라벨은 placeholder 가 아니라 `aria-label` 로 준다 —
 * placeholder 만으로는 입력 후 이름이 사라진다.
 */
export type SearchInputProps = {
  value: string
  onChange: (value: string) => void
  /** 예: t('filter.search.alarms') */
  placeholder: string
  /** 접근성 이름. 없으면 placeholder 를 쓴다 */
  label?: string | undefined
  /**
   * 검색칸 옆 보조 글자. ⚠ 지금 쓰는 곳이 없다 — 작업 · 이력의 「지금 쪽 안에서만」 안내는 eric 지시로 뺐다(2026-09-30).
   * 입력의 `aria-describedby` 로 이어져 스크린리더도 읽는다. 없으면 DOM 이 종전 그대로다.
   */
  hint?: string | undefined
}

export function SearchInput({ value, onChange, placeholder, label, hint }: SearchInputProps) {
  const id = useId()
  const hintId = `${id}-hint`

  const box = (
    <div className="a-search">
      <svg
        aria-hidden="true"
        className="a-icon a-icon--sm"
        fill="none"
        focusable="false"
        stroke="currentColor"
        strokeWidth={2.2}
        viewBox="0 0 24 24"
      >
        <circle cx="11" cy="11" r="7" />
        <path d="M20 20l-4-4" strokeLinecap="round" />
      </svg>
      <input
        {...(hint === undefined ? {} : { 'aria-describedby': hintId })}
        aria-label={label ?? placeholder}
        className="a-search__input"
        id={id}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        type="search"
        value={value}
      />
    </div>
  )

  if (hint === undefined) return box
  return (
    <>
      {box}
      <span className="a-search__hint" id={hintId}>
        {hint}
      </span>
    </>
  )
}
